import React from 'react';
import '../assets/ModificationHistoryModal.css';

const ModificationHistoryModal = ({ payment, onClose }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-SG', { 
      timeZone: 'Asia/Singapore',
      day: '2-digit', 
      month: 'short', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatCurrency = (amount) => {
    return `$${amount.toFixed(2)}`;
  };

  const formatAction = (action) => {
    const actionMap = {
      'created': 'Created',
      'updated': 'Updated',
      'activated': 'Activated',
      'deactivated': 'Deactivated',
      'auto_deactivated': 'Auto-Deactivated'
    };
    return actionMap[action] || action;
  };

  const getActionColor = (action) => {
    const colorMap = {
      'created': '#4CAF50',
      'updated': '#2196F3',
      'activated': '#4CAF50',
      'deactivated': '#FF9800',
      'auto_deactivated': '#f44336'
    };
    return colorMap[action] || '#666';
  };

  const renderHistoryEntry = (entry, index) => {
    const hasAmountChange = entry.previousAmount !== undefined && entry.newAmount !== undefined;
    const hasReasonChange = entry.previousReason !== undefined && entry.newReason !== undefined;

    return (
      <div key={index} className="history-entry">
        <div className="entry-header">
          <span 
            className="action-badge" 
            style={{ backgroundColor: getActionColor(entry.action) }}
          >
            {formatAction(entry.action)}
          </span>
          <span className="entry-date">{formatDate(entry.modifiedAt)}</span>
        </div>
        
        <div className="entry-details">
          {entry.modifiedBy?.name && (
            <div className="detail-item">
              <span className="detail-label">By:</span>
              <span className="detail-value">{entry.modifiedBy.name}</span>
            </div>
          )}
          
          {!entry.modifiedBy && entry.action === 'auto_deactivated' && (
            <div className="detail-item">
              <span className="detail-label">By:</span>
              <span className="detail-value system">System</span>
            </div>
          )}

          {hasAmountChange && (
            <div className="detail-item">
              <span className="detail-label">Amount:</span>
              <div className="change-indicator">
                <span className="old-value">{formatCurrency(entry.previousAmount)}</span>
                <span className="arrow">→</span>
                <span className="new-value">{formatCurrency(entry.newAmount)}</span>
              </div>
            </div>
          )}

          {entry.reason && (
            <div className="detail-item">
              <span className="detail-label">Note:</span>
              <span className="detail-value">{entry.reason}</span>
            </div>
          )}
        </div>

        {hasReasonChange && (
          <div className="reason-change-compact">
            <div className="reason-item old-reason">
              <span className="reason-label-compact">Old:</span>
              <span className="reason-text-compact">{entry.previousReason}</span>
            </div>
            <div className="reason-item new-reason">
              <span className="reason-label-compact">New:</span>
              <span className="reason-text-compact">{entry.newReason}</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Modification History</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* Payment Info */}
          <div className="payment-info">
            <div className="info-row">
              <span className="info-label">Tutor:</span>
              <span className="info-value">{payment.tutor?.name || 'Unknown'}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Current Amount:</span>
              <span className="info-value">{formatCurrency(payment.amount)}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Type:</span>
              <span className="info-value">{payment.type}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Status:</span>
              <span className={`status-badge ${payment.isActive ? 'active' : 'inactive'}`}>
                {payment.isActive ? 'Active' : 'Inactive'}
              </span>
            </div>
          </div>

          {/* History Timeline */}
          <div className="history-timeline">
            <h4>Change History</h4>
            {payment.modificationHistory && payment.modificationHistory.length > 0 ? (
              <div className="history-entries">
                {payment.modificationHistory
                  .slice()
                  .sort((a, b) => new Date(b.modifiedAt) - new Date(a.modifiedAt))
                  .map((entry, index) => renderHistoryEntry(entry, index))}
              </div>
            ) : (
              <div className="no-history">
                <p>No modification history available</p>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModificationHistoryModal;
